export default __webpack_public_path__ + "static/media/SouthernScripts.479f1a7b.svg";